import React, { Component } from 'react';
import axios from 'axios';
import {path} from './routes.js';

export default class UserHomeScreen extends Component{
	constructor(props){
		super(props);
		this.state = {earned:'0',redeemable:'0',redeemed:'0',sent:'0',received:'0',cap:'240'};
	}

	componentDidMount(){ //when component mounts, retrieve user stats from db (earned points, redeemed points, pending points, redeemable points, sent thankyous, received thankyous)
		axios({
			method:'post',
			url:path,headers:{'Content-Type':'application/json'},
			data:{endpoint:'info',table:'points',userID:this.props.userInfo.userID,name:this.props.userInfo.name}
		}).then((response)=>{
			let data = response.data.data;
			this.setState(data[0]);
		});
	}

	componentDidUpdate(prevProps){ //get new user stats after they have performed an action that would alter any of their current stats
		if(prevProps.submitted !== this.props.submitted){
			axios({
				method:'post',
				url:path,headers:{'Content-Type':'application/json'},
				data:{endpoint:'info',table:'points',userID:this.props.userInfo.userID,name:this.props.userInfo.name}
			}).then((response)=>{
				let data = response.data.data;
				this.setState(data[0]);
			});
		}
	}

	render(){
		let content;
		let pStyle = "f3 bb b--light-silver navy";
		if(this.props.active){
			content = <div className="pa2 br4 bg-white mt5 mb5 center userHomeDiv">
									<div style={{maxWidth:'70%',margin:'auto',minWidth:'70%'}}>
										<div><h1>Welcome, {this.props.userInfo.name}!</h1></div>
										<div><p className={pStyle}>Points Earned: {this.state.earned}/{this.state.cap}</p></div>
										<div><p className={pStyle}>Points Redeemable: {this.state.redeemable}/{this.state.cap}</p></div>
										<div><p className={pStyle}>Points Redeemed: {this.state.redeemed}/{this.state.cap}</p></div>
										<div><p className={pStyle}>Sent Thank-yous: {this.state.sent}</p></div>
										<div><p className={pStyle}>Received Thank-yous: {this.state.received}</p></div>
									</div>
								</div>;
		}
		return(
			<div>
			{content}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/UserHomeScreen.js